import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LogementService } from "../services/logement.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class NoLogementGuard  {


  constructor(private logementService: LogementService,
              private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.logementService.hasLogement().pipe(map(has => {
      if (!has) {
        if (isDevMode()) {
          console.warn("Vous n'avez aucun logement.");
        }
        this.router.navigate(['/mes-logements/creer']);
      }
      return has;
    }));
  }

}
